module.exports = __webpack_public_path__ + "media/images/operation_jobs/door_close_washer-0159d151ebc88ed63acb0e9ea867b74d.gif";